export const getPriceFromPriceCategories = (
  selectedAdvancedProductFabric,
  price_fabric_category,
) => {

  let currentPriceCategory
  let currentPriceCategoryArray

  if (!price_fabric_category || price_fabric_category.length === 0) return null
  if(!selectedAdvancedProductFabric) return null

  if (Object.values(selectedAdvancedProductFabric?.combinationFabrics ?? {}).length > 0) {
    // getting all group numbers from selectedAdvancedProductFabric.combinationFabrics
    //console.log('selectedAdvancedProductFabric.combinationFabrics :>> ', selectedAdvancedProductFabric.combinationFabrics)
    const groupNumbers = Object.values(
      selectedAdvancedProductFabric.combinationFabrics,
    ).map(
      (option: any) =>
        option.fabricGroupObject.form_price_fabric_category.group_number,
    )

    // filter unique group numbers by group_number
    const uniqueGroupNumbers = groupNumbers.filter(
      (value, index, self) => self.indexOf(value) === index,
    )
   // console.log('uniqueGroupNumbers :>> ', uniqueGroupNumbers)
    // filter the price fabric category by group number
    currentPriceCategoryArray = price_fabric_category.filter((category) =>
      uniqueGroupNumbers.includes(category.fabrice_price_category.group_number),
    )
  } else {
    currentPriceCategoryArray = price_fabric_category.filter(
      (category) =>
        category.fabrice_price_category.group_number ===
        selectedAdvancedProductFabric.fabricGroupObject
          .form_price_fabric_category.group_number,
    )
  }


  if (currentPriceCategoryArray.length === 0) return null  //
  // find highest price
  //console.log('currentPriceCategoryArray :>> ', currentPriceCategoryArray)
  currentPriceCategory = currentPriceCategoryArray?.reduce((prev, current) =>
    prev && prev.price > current.price ? prev : current,
  )
  //console.log('currentPriceCategory?.price :>> ', currentPriceCategory?.price)
  return currentPriceCategory?.price
}
